{
    "Profile_Summary_Header.incompleteHeader": "Nearly there!",
    "Profile_Summary_Header.incompleteLabel": "Still some more details needed for the next step.",
    "Profile_Summary_Header.submittedHeader": "10-4",
    "Profile_Summary_Header.submittedLabel": "We are reviewing your application.",
    "Profile_Summary_Header.acceptedHeader": "All clear!",
    "Profile_Summary_Header.acceptedLabel": "Your application cleared our checks, we are working on finding the best quotes for you.",
    "Profile_Summary_Header.rejectedHeader": "Oh dear!",
    "Profile_Summary_Header.rejectedLabel": "Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.declinedHeader": "Declined",
    "Profile_Summary_Header.declinedLabel": "This referral has been declined.",
    "Profile_Summary_Header.referredHeader": "Oh dear!",
    "Profile_Summary_Header.referredLabel": "Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.underwritingRequiredHeader": "Oh dear!",
    "Profile_Summary_Header.underwritingRequiredLabel": "Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.cancelledHeader": "Policy Cancelled",
    "Profile_Summary_Header.cancelledLabel": "This policy was cancelled.",
    "Profile_Summary_Header.deletedHeader": "Cancellation deleted",
    "Profile_Summary_Header.deletedLabel": "This cancellation was deleted and is no longer in progress.",
    "Profile_Summary_Header.quotedHeader": "We've shopped around for you!",
    "Profile_Summary_Header.quotedLabel": "And found some great deals. See all the details below.",
    "Profile_Summary_Header.quoteIssuedHeader": "We've shopped around for you!",
    "Profile_Summary_Header.quoteIssuedLabel": "And found some great deals. See all the details below.",
    "Profile_Summary_Header.quoteAcceptedHeader": "Great!",
    "Profile_Summary_Header.quoteAcceptedLabel": "Don't forget to review the nitty-gritties below.",
    "Profile_Summary_Header.lostHeader": "Lost!",
    "Profile_Summary_Header.lostLabel": "Kate, we have to go back!",
    "Profile_Summary_Header.abandonedHeader": "Abandon Ship!",
    "Profile_Summary_Header.abandonedLabel": "This submission was abandoned along the way!",
    "Profile_Summary_Header.bindRequestedHeader": "The ball is in our court!",
    "Profile_Summary_Header.bindRequestedLabel": "You're in the home stretch. You will be notified by email when the customer completes the payment.",
    "Profile_Summary_Header.boundHeader": "We've got that ball rolling!",
    "Profile_Summary_Header.boundLabel": "We'll reach out when we've collected all of your official documentation.",
    "Profile_Summary_Header.issuedHeader": "You're all done!",
    "Profile_Summary_Header.issuedLabel": "Download your policy documents below.",
    "Profile_Summary_Header.quotingHeader": "Nearly there!",
    "Profile_Summary_Header.quotingLabel": "Your Quote is being calculated.",

    "Profile_Summary_Header.Badge.Authorized": "Authorized",
    "Profile_Summary_Header.Badge.NotAuthorized": "Not Authorized",
    "Profile_Summary_Header.Badge.PolicyIssued": "Policy Documents Issued",
    "Profile_Summary_Header.Badge.ProposalIssued": "Proposal Issued",
    "Profile_Summary_Header.Badge.NotIssued": "Policy Documents Not Issued",
    "Profile_Summary_Header.Badge.Paid": "Paid",
    "Profile_Summary_Header.Badge.NotPaid": "Not Paid",
    "Profile_Summary_Header.Badge.None": "None",
    "Profile_Summary_Header.Badge.Incomplete": "Incomplete",
    "Profile_Summary_Header.Badge.Submitted": "Submitted",
    "Profile_Summary_Header.Badge.Abandoned": "Abandoned",
    "Profile_Summary_Header.Badge.Accepted": "Accepted",
    "Profile_Summary_Header.Badge.Declined": "Declined",
    "Profile_Summary_Header.Badge.Quoted": "Quoted",
    "Profile_Summary_Header.Badge.QuotedIndicative": "Quoted (indicative)",
    "Profile_Summary_Header.Badge.UnderwritingRequired": "Underwriting Required",
    "Profile_Summary_Header.Badge.Referred": "Referred",
    "Profile_Summary_Header.Badge.QuoteIssued": "Quote Issued",
    "Profile_Summary_Header.Badge.BindRequested": "Bind Requested",
    "Profile_Summary_Header.Badge.Bound": "Bound",
    "Profile_Summary_Header.Badge.Issued": "Issued",
    "Profile_Summary_Header.Badge.Lost": "Lost",
    "Profile_Summary_Header.Badge.Cancelled": "Cancelled",
    "Profile_Summary_Header.Badge.Deleted": "Deleted",
    "Profile_Summary_Header.Badge.QuoteAccepted": "Quote Accepted",
    "Profile_Summary_Header.Badge.Quoting": "Quoting"
}
